import { FetchResult } from '@apollo/client'
import { FlagsContextModel } from 'config/useFlagsContext'
import {
  AtendimentoIndividualRetificacaoViewQuery,
  AtendimentoVacinacaoRetificacaoViewQuery,
  RetificacaoAtendimentoInput,
  RetificacaoAtendimentoVacinacaoInput,
  RetificarAtendimentoMutation,
  RetificarAtendimentoVacinacaoMutation,
  TipoAtendimentoProfissional,
} from 'graphql/types.generated'

export type AtendimentoIndividualRetificacaoModel = AtendimentoIndividualRetificacaoViewQuery['atendimentoIndividual']

export type AtendimentoVacinacaoRetificacaoModel = AtendimentoVacinacaoRetificacaoViewQuery['atendimentoIndividual']
export type VacinacaoRetificacaoModel = AtendimentoVacinacaoRetificacaoModel['vacinacao']

export enum RetificacaoAtendimentoOpcaoEnum {
  EDITAR_REGISTRO = 'EDITAR_REGISTRO',
  REMOVER_REGISTRO = 'REMOVER_REGISTRO',
}

export interface RetificacaoAtendimentoModel {
  id: ID
  tipo: RetificacaoAtendimentoOpcaoEnum
  justificativa: string
}

export interface RetificacaoAtendimentoButtonModel {
  profissional?: {
    id: string
  }
  cbo?: {
    id: string
  }
  unidadeSaude?: {
    id: string
  }
  equipe?: {
    id: string
  }
  isInativo: boolean
  isVersaoFichaRetificavel: boolean
}

export type FlagsRetificacao = Pick<
  FlagsContextModel,
  | 'PILOTO_RETIFICACAO_ATENDIMENTO_PROCEDIMENTOS_ENABLED'
  | 'RETIFICACAO_ATENDIMENTO_VACINACAO_ENABLED'
  | 'RETIFICACAO_ATENDIMENTO_INDIVIDUAL_ENABLED'
>

export const tipoAtendimentoRetificacaoRecord: Partial<Record<
  TipoAtendimentoProfissional,
  { baseRoute: string; title: string }
>> = {
  [TipoAtendimentoProfissional.CONSULTA]: {
    baseRoute: '/lista-atendimento/atendimento-individual',
    title: 'atendimento individual',
  },
  [TipoAtendimentoProfissional.ATENDIMENTO_PROCEDIMENTOS]: {
    baseRoute: '/lista-atendimento/atendimento-individual',
    title: 'atendimento de procedimentos',
  },
  [TipoAtendimentoProfissional.VACINACAO]: {
    baseRoute: '/lista-atendimento/atendimento-vacinacao',
    title: 'atendimento de vacinação',
  },
}

export interface RetificacaoConfirmModalOptions<FormModel, MutationResult> {
  initialValues: FormModel
  currentValues: FormModel
  nomeCidadao: string
  onRetificar: () => Promise<FetchResult<MutationResult>>
  onRetificarSemAlteracoes: () => void
  tipoAtendimentoProfissional: TipoAtendimentoProfissional
}

export type RetificacaoInput = RetificacaoAtendimentoInput | RetificacaoAtendimentoVacinacaoInput

export type RetificarMutations = RetificarAtendimentoMutation | RetificarAtendimentoVacinacaoMutation
